import * as yup from 'yup'

export class NeedsToBeTakenToSecretaryOfStateDetailsDto {
  ownerName?: string = undefined
  dropOffDate?: string = undefined
  time?: string = undefined
  branchLocation?: string = undefined
  count?: number = undefined
  description?: string = undefined
  titleApplicationDeliveryPhotoFileName?: string = undefined
  titleApplicationDeliveryPhotoFile?: File = undefined
}

export const needsToBeTakenToSecretaryOfStateDetailsValidationSchema = yup.object({
  ownerName: yup.string().nullable(),
  dropOffDate: yup.string().nullable(),
  time: yup.string().nullable(),
  branchLocation: yup.string().nullable(),
  count: yup.number().nullable(),
  description: yup.string().nullable()
})
